import { render, staticRenderFns } from "./AlarmMiss1.vue?vue&type=template&id=fc206dec&scoped=true&"
import script from "./AlarmMiss1.vue?vue&type=script&lang=js&"
export * from "./AlarmMiss1.vue?vue&type=script&lang=js&"
import style0 from "./AlarmMiss1.vue?vue&type=style&index=0&id=fc206dec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc206dec",
  null
  
)

export default component.exports